import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';

const STORAGE_KEY = 'mpa-lang';
const SUPPORTED = ['en', 'zh', 'hi'];

const storedLang = (() => {
  try {
    const l = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(l) ? l : 'en';
  } catch (_e) {
    return 'en';
  }
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      hi: { translation: hi },
    },
    lng: storedLang,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', lng);
    }
  } catch (_e) { /* no-op */ }
});

// Set initial html lang
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', storedLang);
}

export default i18n;
export { SUPPORTED };
